import type { FC } from 'react';

import type { MessageProps } from 'src/components/common/Messages/index';
import Message from 'src/components/common/Messages/index';

import { styles } from './ErrorMessage.styles';

export const ERROR_MESSAGE_TEST_ID = 'error-message';

const ErrorMessage: FC<MessageProps> = ({
  align,
  children,
  className,
  sx,
  ...boxProps
}) => (
  <Message
    align={align}
    className={className}
    sx={[styles.errorMsg, ...(Array.isArray(sx) ? sx : [sx])]}
    data-test-id={ERROR_MESSAGE_TEST_ID}
    {...boxProps}
  >
    {children}
  </Message>
);

export default ErrorMessage;
